module.exports = __webpack_public_path__ + "img/226.aeeda030.jpg";